import { useContext } from "react";

import { IStores, StoreContext } from "./StoreContext";

export function useStores(): IStores {
    return useContext(StoreContext);
}
